const minChipLabel = 3

export {
   minChipLabel
}